import React from "react";

export interface InputLabel {
  isRight?: boolean;
  fontSize: string;
}

const InputLabel: React.FC<React.PropsWithChildren<InputLabel>> = ({
  children,
  isRight,
  fontSize,
}) => {
  return (
    <span
      className={`inline-flex h-full box-border items-center pointer-events-none m-0 py-0 px-2 text-gray-500 bg-gray-100 border-gray-200 border rounded-md leading-none ${fontSize} ${
        isRight
          ? "right border-l-0 rounded-tl-none rounded-bl-none"
          : "border-r-0 rounded-tr-none rounded-br-none"
      }`}
    >
      {children}
    </span>
  );
};

const MemoInputLabel = React.memo(InputLabel);

export default MemoInputLabel;
